if (!customElements.get('split-slider')) {
  class SplitSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.button = this.querySelector('[js-dynamic-button]');
      this.buttonDefaultHref = this.button?.getAttribute('href');
      this.swiperElement = this.querySelector('.swiper');

      this.prevArrow = this.querySelector('.swiper-arrow--prev');
      this.nextArrow = this.querySelector('.swiper-arrow--next');

      this.querySelectorAll('[js-arrow-dummy]').forEach((dummy) => {
        dummy.addEventListener('click', () => {
          const target =
            dummy.getAttribute('js-arrow-dummy') === 'next'
              ? this.nextArrow
              : this.prevArrow;
          target?.click();
        });
      });

      const slides = this.querySelectorAll('.swiper-slide');
      const urls = Array.from(slides).map((slide) =>
        slide.getAttribute('js-button-url'),
      );

      this.slider = new Swiper(this.swiperElement, {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
        on: {
          slideChange: (swiper) => {
            if (!this.button) return;

            this.button.setAttribute(
              'href',
              urls[swiper.realIndex] || this.buttonDefaultHref,
            );
          },
        },
      });
    }

    destroySlider() {
      this.slider.destroy();
    }
  }

  customElements.define('split-slider', SplitSlider);
}